import angular from 'angular';

import { configureFDO } from '@/core/hostmanagement/fdo/fdo.service';
import { configureAMT } from 'ShbDeployer/hostmanagement/open-amt/open-amt.service';

angular.module('shbdeployer.app').controller('SettingsEdgeComputeController', SettingsEdgeComputeController);

/* @ngInject */
export default function SettingsEdgeComputeController($q, $async, $state, Notifications, SettingsService, StateManager) {
  var ctrl = this;

  this.onSubmitEdgeCompute = async function (settings) {
    try {
      await SettingsService.update(settings);
      Notifications.success('Готово', 'Настройки сохранены');
      StateManager.updateEnableEdgeComputeFeatures(settings.EnableEdgeComputeFeatures);
      $state.reload();
    } catch (err) {
      Notifications.error('Ошибка', err, 'Не удалось сохранить настройки');
    }
  };

  this.onSubmitOpenAMT = async function (formValues) {
    try {
      await configureAMT(formValues);
      Notifications.success('Готово', formValues.enabled ? 'OpenAMT успешно включен' : 'OpenAMT успешно отключен');
      $state.reload();
    } catch (err) {
      Notifications.error('Ошибка', err, 'Не удалось применить изменения');
    }
  };

  this.onSubmitFDO = async function (formValues) {
    try {
      await configureFDO(formValues);
      Notifications.success('Готово', formValues.enabled ? 'FDO успешно включен' : 'FDO успешно отключен');
      $state.reload();
    } catch (err) {
      Notifications.error('Ошибка', err, 'Не удалось применить изменения');
    }
  };

  function initView() {
    $async(async () => {
      try {
        ctrl.settings = await SettingsService.settings();
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось загрузить настройки приложения');
      }
    });
  }

  initView();
}
